var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-circle",
    d: "M4,24A20,20,0,1,1,24,44,20.016,20.016,0,0,1,4,24Zm3.333,0A16.667,16.667,0,1,0,24,7.333,16.694,16.694,0,0,0,7.333,24Zm13.7-8.25L23.4,13.4,34,24,23.4,34.6l-2.367-2.35,6.583-6.583H14V22.333H27.617Z",
    transform: "translate(-4 -4)",
    fill: "#003865",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.2784667395a4e2522221ccd20ad6a52e.svg";
export { ForwardRef as ReactComponent };